An opaque string cursor for retrieving the next page of results.
